import { Component, OnInit, EventEmitter, Output, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { LanguageDetails } from '../../../models/general.model';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { AppService } from '../../../services/app.service';
import { MasterService } from '../../../services/master.service';

@Component({
  selector: 'app-language-edit-form',
  templateUrl: './language-edit-form.component.html',
  styleUrls: ['./language-edit-form.component.scss']
})
export class LanguageEditFormComponent implements OnInit {
@Output() closeDialogue = new EventEmitter();
  
  rmList : any = [];
  dialogHeader : string = "";

  fhMapping : any = [];
  generalId : Number = 0;
  formGroup: FormGroup;
  formGroupErrors: any;
  languageDetails = new LanguageDetails();

  loadingIndicator = false;
  reorderable = true;

  translations: any;
  
  constructor( @Inject(MAT_DIALOG_DATA)
  public data: { Id : 0, type: 0 },
  public dialog: MatDialog,
  private formBuilder: FormBuilder,
  public appService: AppService,
  private masterService: MasterService,
  public dialogRef: MatDialogRef<LanguageEditFormComponent>){
    this.appService.showLoading();
    this.setPageTranslations();
    this.formGroupErrors = {
        Code :{},
        Description: {}
    };

    this.formGroup = this.formBuilder.group({
        Code:['',Validators.required],
        Description: ['', Validators.required]
        });
    this.generalId = this.data.Id;
  }
  
  ngOnInit() {
    this.select();
  }
  setPageTranslations(){
    this.translations = JSON.parse(sessionStorage.getItem('pageData')); 
  } 
  select(): void{
    this.masterService.selectLanguage(this.generalId).subscribe(
      res => this.selectSuccess(res),
      error => this.apiFaillure(error)
    );
  }
  selectSuccess(res): void{
    if (res.Status) {
      if(res.Data != 'null' && JSON.parse(res.Data).length > 0)
        this.rmList = JSON.parse(res.Data);
      else
        this.apiFaillure("No data");
    } else {
      this.apiFaillure(res.Message);
    }
    this.appService.hideLoading();
  }
  apiFaillure(error): void {
    this.appService.hideLoading();
    this.appService.showDialogue(this.translations.hdError, error);
  }
  close(){
    this.dialogRef.close();
  }
  save(): void{
    this.appService.showLoading();
    this.masterService.saveGeneralByLanguage(JSON.stringify(this.rmList)).subscribe(
      res => this.languageMappingSuccess(res),
      error => this.apiFaillure(error)
    );
  }
  languageMappingSuccess(res): void{
    this.appService.hideLoading();
    if (res.Status == 1) {
      this.appService.showDialogue(this.translations.hdSuccess,this.translations[res.Message])
      .afterClosed().subscribe(result => {
          if (result) {
            this.close();
          }          
      });    
    } else {
      this.apiFaillure(this.translations[res.Message]);
    }
  }
}






// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/general/language-edit-form/language-edit-form.component.ts